import { ReactNode } from "react";
import { useFormContext } from "./form-context";

interface Props {
  name: string;
  children: ReactNode;
}

const FormGroup: React.FC<Props> = ({ name, children }) => {
  const { groups } = useFormContext();
  const isEnabled = !!groups[name];

  if (!isEnabled) return null;

  return <>{children}</>;
};

export default FormGroup;
